import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

interface Activity {
  _id: string;
  pageId?: string;
  pageName: string;
  createdAt: string;
}

export function ContactActivity() {
  const { id } = useParams<{ id: string }>();
  const [activities, setActivities] = useState<Activity[]>([]);

  useEffect(() => {
    async function fetchActivities() {
      if (!id) return;

      try {
        const response = await fetch(`/api/leads/${id}/activity`);
        if (response.ok) {
          const data = await response.json();
          setActivities(data.activities ?? []);
        }
      } catch (error) {
        console.error("Failed to fetch activities:", error);
      }
    }

    fetchActivities();
  }, [id]);

  const formatTimestamp = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  return (
    <div className="divide-y">
      {activities.length === 0 ? (
        <p className="text-muted-foreground text-sm py-4">No activity yet</p>
      ) : (
        activities.map((activity) => (
          <div key={activity._id} className="py-3 first:pt-0">
            <div>
              Submitted{" "}
              {activity.pageId ? (
                <Link
                  to={`/pages/${activity.pageId}/edit`}
                  className="text-blue-600 dark:text-blue-400 underline underline-offset-2 hover:opacity-80"
                >
                  {activity.pageName}
                </Link>
              ) : (
                activity.pageName
              )}
            </div>
            <div className="text-muted-foreground text-sm mt-1">
              {formatTimestamp(activity.createdAt)}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
